import { borderFlagsLeft } from 'assets/js/editor/table/table';
import tableQuery from 'assets/js/editor/table/table-query';

import template from './edit-cell-border.hbs';

module.exports = Backbone.View.extend({
  events: {
    'click .color-bullet': 'calculateColorPickerPosition',
    'click a.btn-onmenu[data-action="set_apply-to"]': 'setPosition',
    'click div.stroke-icon': 'setStrokeDash',
    'click span.up-arrow': 'increaseStrokeWidth',
    'click span.down-arrow': 'decreaseStrokeWidth',
    'input div.tab-slider input[name="stroke-width"]': 'slideStrokeWidth',
    'click [name="cell-stroke-menu"]': 'toggleCellStrokeMenu'
  },
  strokeFill: '#000000',
  strokeWidth: 2,
  strokeDashArray: 0,
  strokeDashOffset: 0,
  position: 'all', // Valid values: all, horizontal, vertical, top, bottom, left, right, outer, inner

  initialize: function (options) {
    _.bindAll(this, 'setBorderFill', 'hideStrokeMenu');

    this.element = options.selectedElement;
    this.canvas = options.canvas;
    this.popupMenuCommonFunctions = options.popupMenuCommonFunctions;
    this.render();
  },
  render: function () {
    this.$el.html(template({
      strokeWidth: this.strokeWidth
    }));

    this.initStyleData();
    this.initColorPicker();
    this.initStrokeWidth();
    this.initStrokeDash();

    // Trigger a blur event so tooltip fades away
    const dropdownTitleElement = this.el.parentElement;
    dropdownTitleElement && dropdownTitleElement.dispatchEvent(new Event('blur'));
  },

  initStyleData: function () {
    const selectedRectElement = this.element.querySelector('rect.table-cell-selected');
    const borderElement = selectedRectElement
      ? tableQuery.getBorderElementByCell(selectedRectElement.closest('.table-cell'), borderFlagsLeft)
      : this.element.querySelector('line.table-border');

    this.strokeWidth = Number(borderElement.getAttribute('stroke-width')) || 0;
    this.strokeFill = borderElement.getAttribute('stroke') || '#000000';
    this.strokeDashArray = Number(borderElement.getAttribute('stroke-dasharray')?.split(' ')[0]) || 0;
    this.strokeDashOffset = Number(borderElement.getAttribute('stroke-dashoffset')) || 0;
  },

  initStrokeWidth: function () {
    const input = this.el.querySelector('div.tab-stroke-weight input[name="stroke-width"]');
    const sliderInput = this.el.querySelector('div.tab-slider input[name="stroke-width"]');

    sliderInput.value = this.strokeWidth;
    input.value = this.strokeWidth;
  },

  initStrokeDash: function () {
    const activeStrokeDash = this.el.querySelector(`div.stroke-icon[data-dash-array="${this.strokeDashArray}"]:not([data-stroke-width])`);
    activeStrokeDash && this.toggleActiveButton(activeStrokeDash);
  },

  initColorPicker: function () {
    const colorPickerRegion = this.el.querySelector('.ui-dropdown-items');

    if (colorPickerRegion) {
      this.popupMenuCommonFunctions.drawColor(this.element, 0, colorPickerRegion, (value) => {
        this.setBorderFill(value);
        this.showColorPicker(false);
      });
    }

    const colorButton = this.el.querySelector('.border-add-color');
    if (colorButton) {
      const colorBullet = colorButton.querySelector('.color-bullet');
      if (colorBullet) {
        colorBullet.style.color = this.strokeFill;
      }
    }
    colorButton.setAttribute('data-value', this.strokeFill);
  },

  calculateColorPickerPosition: function () {
    this.showColorPicker(true);
    this.hideStrokeMenu();
  },

  toggleCellStrokeMenu: function () {
    const subMenu = this.el.querySelector('.stroke-dropdown');
    if (subMenu.classList.contains('visible')) {
      subMenu.classList.remove('visible');
    } else {
      subMenu.classList.toggle('visible');
    }
  },

  hideStrokeMenu: function () {
    const subMenu = this.el.querySelector('.stroke-dropdown');
    if (subMenu.classList.contains('visible')) {
      subMenu.classList.remove('visible');
    }
  },

  /**
   *
   * @param {boolean} show
   */
  showColorPicker: function (show = true) {
    const colorButton = this.el.querySelector('.border-add-color');
    const colorPicker = colorButton.querySelector('.ui-dropdown-items');
    colorPicker.style.display = show ? 'block' : 'none';
  },

  setStrokeDash: function (event) {
    const targetButton = event.target.closest('.stroke-icon');
    const strokeWidth = targetButton.dataset.strokeWidth;
    const strokeDash = targetButton.dataset.dashArray;
    const strokeDashOffset = targetButton.dataset.dashOffset;

    if (strokeWidth) {
      this.strokeWidth = Number(strokeWidth);
    } else if (!this.strokeWidth) {
      this.strokeWidth = 2;
    }

    if (strokeDash) {
      this.strokeDashArray = Number(strokeDash) || 0;
    }

    if (strokeDashOffset) {
      this.strokeDashOffset = Number(strokeDashOffset) || 0;
    }

    this.toggleActiveButton(targetButton);
    this.renderStrokeDash();
  },

  renderStrokeDash: function () {
    const data = {
      position: this.position,
      strokeWidth: this.strokeWidth,
      strokeDash: this.strokeDashArray,
      strokeDashOffset: this.strokeDashOffset
    };

    INKIVE.DesignFacade.set({
      stroke_dash: data
    });
  },

  toggleActiveButton: function (button) {
    this.el.querySelectorAll('.stroke-icon.select-active').forEach((activeButton) => {
      activeButton.classList.remove('select-active');
    });

    button.classList.add('select-active');
  },

  setPosition: function (event) {
    const targetButton = event.target.closest('.btn-onmenu');
    this.position = targetButton.getAttribute('value');
    this.toggleAppliedButton(targetButton);
  },

  toggleAppliedButton: function (button) {
    this.el.querySelectorAll('.btn-onmenu.applied').forEach((appliedButton) => {
      appliedButton.classList.remove('applied');
    });

    button.classList.add('applied');
  },

  setBorderFill: function (value) {
    this.strokeFill = value;
    this.renderBorderFill();
  },

  renderBorderFill: function () {
    const data = {
      position: this.position,
      strokeFill: this.strokeFill
    };

    INKIVE.DesignFacade.set({
      stroke_fill: data
    });
  },

  increaseStrokeWidth: function (event) {
    const button = event && event.currentTarget;
    if (!button) return;

    const input = this.el.querySelector('div.tab-stroke-weight input[name="stroke-width"]');
    const sliderInput = this.el.querySelector('div.tab-slider input[name="stroke-width"]');

    input.stepUp();
    this.strokeWidth = Number(input.value);
    sliderInput.value = this.strokeWidth;

    this.renderStrokeWidth();
  },

  decreaseStrokeWidth: function (event) {
    const button = event && event.currentTarget;
    const sliderInput = this.el.querySelector('div.tab-slider input[name="stroke-width"]');

    if (!button) return;

    const input = this.el.querySelector('div.tab-stroke-weight input[name="stroke-width"]');
    input.stepDown();
    this.strokeWidth = Number(input.value);
    sliderInput.value = this.strokeWidth;

    this.renderStrokeWidth();
  },

  slideStrokeWidth: function () {
    const sliderInput = this.el.querySelector('div.tab-slider input[name="stroke-width"]');
    const input = this.el.querySelector('div.tab-stroke-weight input[name="stroke-width"]');

    this.strokeWidth = Number(sliderInput.value);
    input.value = this.strokeWidth;

    this.renderStrokeWidth();
  },

  renderStrokeWidth: function () {
    const data = {
      position: this.position,
      strokeWidth: this.strokeWidth
    };

    INKIVE.DesignFacade.set({
      stroke_width: data
    });
  }
});
